import type { AssignmentProcess, StepActionType } from '@bliks-io/contracts';

/**
 * For tasks the output lives on task.output; for decisions we match
 * the specific rule that was followed via ruleIds. Returns null when
 * no output applies.
 */
export function resolveStepOutput(
  step: {
    actionType: StepActionType;
    task?: { output?: string };
    rules?: Array<{ _id?: string; output?: string }>;
  },
  ruleIds?: string[]
): string | null {
  if (step.actionType === 'task') return step.task?.output ?? null;
  if (ruleIds && step.rules) {
    return step.rules.find((r) => r._id && ruleIds.includes(r._id))?.output ?? null;
  }
  return null;
}

/**
 * Transforms an AssignmentProcess for display
 */
export function transformProcessForDisplay(process: AssignmentProcess) {
  return {
    name: process.name,
    department:
      typeof process.department === 'object' && process.department !== null
        ? {
            _id: process.department._id,
            name: process.department.name,
            abbreviation: process.department.abbreviation
          }
        : undefined
  };
}
